import styled from "styled-components";
import ustav from "../files/Оинномаи АБТ- 2024.docx"
import reg from "../files/4 A b) ЛИЦЕНЗИЯ.pdf"
import ENN from "../files/ЕНН.pdf"
import { useTranslation } from 'react-i18next';



import { Container } from "../style";



const AppStyled = styled.div`

`


const Content = styled.div`
padding: 20px 0;
background-color: #F5F5F4;
`

function Docs() {
    const { t } = useTranslation();
  return (
    <Container>
    <br /> <br />
    <div className="documents">
      <header className="documents__header">
        <h1 className="documents__title">{t('documents.title')}</h1>
        <p className="documents__description">
          {t('documents.description')}
        </p>
      </header>

      <section className="documents-section">
        <h2 className="documents-section__title">
          {t('documents.sections.main.title')}
        </h2>
        <ul className="documents-list">
          <li className="documents-list__item">
            <div className="document">
              <div className="document__icon">📄</div>
              <div className="document__content">
                <h3 className="document__title">
                  {t('documents.documentTypes.charter')}
                </h3>
                <div className="document__info">
                  <span className="document__size">
                    {t('documents.fileInfo.format')}, {t('documents.fileInfo.size', { size: '2.5' })}
                  </span>
                </div>
              </div>
              <a href={ustav} className="document__download">
                {t('documents.fileInfo.download')}
              </a>
            </div>
          </li>
          <li className="documents-list__item">
            <div className="document">
              <div className="document__icon">📄</div>
              <div className="document__content">
                <h3 className="document__title">
                  {t('documents.documentTypes.stateRegistration')}
                </h3>
                <div className="document__info">
                  <span className="document__size">
                    {t('documents.fileInfo.format')}, {t('documents.fileInfo.size', { size: '1.8' })}
                  </span>
                </div>
              </div>
              <a href={reg} className="document__download">
                {t('documents.fileInfo.download')}
              </a>
            </div>
          </li>
        </ul>
      </section>

      <section className="documents-section">
        <ul className="documents-list">
          <li className="documents-list__item">
            <div className="document">
              <div className="document__icon">📄</div>
              <div className="document__content">
                <h3 className="document__title">
                  {t('documents.documentTypes.enn')}
                </h3>
                <div className="document__info">
                  <span className="document__size">
                    {t('documents.fileInfo.format')}, {t('documents.fileInfo.size', { size: '1.2' })}
                  </span>
                </div>
              </div>
              <a href={ENN} className="document__download">
                {t('documents.fileInfo.download')}
              </a>
            </div>
          </li>
          <li className="documents-list__item">
            <div className="document">
              <div className="document__icon">📄</div>
              <div className="document__content">
                <h3 className="document__title">
                  {t('documents.documentTypes.inn')}
                </h3>
                <div className="document__info">
                  <span className="document__size">
                    {t('documents.fileInfo.format')}, {t('documents.fileInfo.size', { size: '0.8' })}
                  </span>
                </div>
              </div>
              <a href={ENN} className="document__download">
                {t('documents.fileInfo.download')}
              </a>
            </div>
          </li>
        </ul>
      </section>

      <div className="notice">
        <p className="notice__text">{t('documents.notice')}</p>
      </div>
    </div>
    <br /> <br />
  </Container>
  );
}

export default Docs;
